module.exports = __webpack_public_path__ + "aa4f220db0a1d34084363dd9f8e81ea9.png";